import React, { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { XIcon, SendIcon } from 'lucide-react';
interface ContactPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export const ContactPopup: React.FC<ContactPopupProps> = ({
  open,
  onOpenChange
}) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, you would send this data to your backend
    console.log({
      name,
      email,
      message
    });
    setSubmitted(true);
  };
  return <Dialog.Root open={open} onOpenChange={onOpenChange} data-id="element-161">
      <Dialog.Portal data-id="element-162">
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-40" data-id="element-163" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-6 max-w-md w-full max-h-[85vh] overflow-y-auto z-50" data-id="element-164">
          <div className="flex justify-between items-start mb-4" data-id="element-165">
            <Dialog.Title className="text-xl font-medium text-[#444]" data-id="element-166">
              Contacto
            </Dialog.Title>
            <Dialog.Close asChild data-id="element-167">
              <button className="text-[#8e7f7a] hover:text-[#444]" data-id="element-168">
                <XIcon size={20} data-id="element-169" />
              </button>
            </Dialog.Close>
          </div>
          {submitted ? <div className="text-center py-6" data-id="element-170">
              <div className="w-16 h-16 bg-[#d4b7a8] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-171">
                <SendIcon size={24} className="text-white" data-id="element-172" />
              </div>
              <h3 className="text-xl font-medium text-[#444] mb-2" data-id="element-173">
                ¡Mensaje enviado!
              </h3>
              <p className="text-[#5a5553]" data-id="element-174">
                Gracias por contactarnos. Responderemos a tu mensaje lo antes
                posible.
              </p>
              <button onClick={() => {
            setSubmitted(false);
            setName('');
            setEmail('');
            setMessage('');
          }} className="mt-4 text-[#d4b7a8] hover:text-[#c8a999]" data-id="element-175">
                Enviar otro mensaje
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-176">
              <div data-id="element-177">
                <label htmlFor="name" className="block text-sm font-medium text-[#5a5553] mb-1" data-id="element-178">
                  Nombre
                </label>
                <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#d4b7a8]" required data-id="element-179" />
              </div>
              <div data-id="element-180">
                <label htmlFor="email" className="block text-sm font-medium text-[#5a5553] mb-1" data-id="element-181">
                  Email
                </label>
                <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#d4b7a8]" required data-id="element-182" />
              </div>
              <div data-id="element-183">
                <label htmlFor="message" className="block text-sm font-medium text-[#5a5553] mb-1" data-id="element-184">
                  Mensaje
                </label>
                <textarea id="message" value={message} onChange={e => setMessage(e.target.value)} rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#d4b7a8]" required data-id="element-185" />
              </div>
              <button type="submit" className="w-full bg-[#d4b7a8] hover:bg-[#c8a999] text-white font-medium py-2 px-4 rounded-md transition-all" data-id="element-186">
                Enviar mensaje
              </button>
            </form>}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>;
};